'use client';
import React, { useEffect, useState } from 'react';
import { SocialIcon } from 'react-social-icons';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { sanityClient } from '../client';
import { Circles, Rings } from 'react-loader-spinner';

function Header() {
  const [socialLinks, setSocialLinks] = useState(null);
  useEffect(() => {
    sanityClient
      .fetch(`*[_type=="social"]`)
      .then((data) => setSocialLinks(data))
      .catch(console.error);
  }, []);
  if (!socialLinks)
    return (
      <div className="flex  items-center justify-center ">
        <Circles height={30} width={30} color="#5bccf6" />
      </div>
    );

  return (
    <header className="sticky static top-0 flex justify-between max-w-7xl p-5 mx-auto z-20 items-start items-center text-base">
      <motion.div
        initial={{ x: -500, opacity: 0, scale: 0.5 }}
        animate={{ x: 0, opacity: 1, scale: 1 }}
        transition={{ duration: 1.5 }}
        className="flex flex-row items-center"
      >
        {/* social Icons */}
        {socialLinks.map((socialLink, index) => (
          <SocialIcon
            title={socialLink?.title}
            key={index}
            url={socialLink?.url}
            fgColor="#030e12"
            bgColor="transparent"
            className="hover:bg-[#5bccf6] transition-all rounded-full duration-300"
            style={{ width: '30px', height: '30px' }}
          />
        ))}
      </motion.div>
      <a href="#contact">
        <motion.div
          initial={{ x: 500, opacity: 0, scale: 0.5 }}
          animate={{ x: 0, opacity: 1, scale: 1 }}
          transition={{ duration: 1.5 }}
          className="flex flex-row text-black items-center text-300 cursor-pointer"
        >
          <SocialIcon
            network="email"
            className="cursor-pointer"
            fgColor="#030e12"
            bgColor="transparent"
            style={{ width: '25px', height: '25px' }}
          />
          <p className="uppercase tracking-widest text-[10px] md:text-sm text-black">
            Hire Me
          </p>
        </motion.div>
      </a>
    </header>
  );
}

export default Header;
